window.addEventListener('pplrAppInitiated', function (e) {
    // Controleer op specifiek product-ID
    const productId = pplr_product?.id;
    const isSpecificProduct = productId === 8502085091675;

    loadScript_p("https://cdn.jsdelivr.net/npm/qrcode/build/qrcode.min.js", () => {
        var prevVal = null;
        var prevTextVal = "";
        const swatchElName = `[name="properties[1. Kies hier de stijl van jouw Socialframe.]"]`;
        const checkSwatchVal = [`Zwart & QR-code`, 'Wit QR-code'];
        const textInputElName = `[name="properties[De link naar jou favoriete nummer website of filmpje hier invoeren.]"]`;
        const svgFilePropertiesName = `properties[_qr_code_svg]`;
        const form = jQuery(".pplr_atc_form");

        let prevSRCS = {
            [checkSwatchVal[0]]: $(".pplr-wrapper.pplr-_pplr_qr_black").find("img.img_url").attr("data-psrc"),
            [checkSwatchVal[1]]: $(".pplr-wrapper.pplr-_pplr_qr_white").find("img.img_url").attr("data-psrc"),
        };

        const colors = {
            [checkSwatchVal[0]]: "#000000",
            [checkSwatchVal[1]]: "#fffffd",
        };

        var file = null;

        const checkVal = () => {
            return jQuery(`input${swatchElName}`).val();
        };
        const inputVal = () => {
            return jQuery(`.pplr_text${textInputElName}`).val();
        };

        const removeSVg = () => {
            jQuery(`[name="${svgFilePropertiesName}"]`).remove();
        };

        const appendFile = () => {
            if (!file) {
                removeSVg();
                return;
            }
            let input = jQuery(`[name="${svgFilePropertiesName}"]`);
            if (input.length < 1) {
                input = jQuery(`<input type="file" style="width:0;height:0;opacity:0;" name="${svgFilePropertiesName}" />`);
                form.append(input);
            }
            input[0].files = file;
            console.log(input[0].files);
        };

        const generateQrCode = () => {
            console.log('Vorige tekstwaarde:', prevTextVal);
            if (!prevTextVal) {
                return;
            }

            // Stel de gewenste grootte van de QR-code in pixels (bijvoorbeeld 150x150)
            const qrSizeInPixels = 150; // Dit blijft de grootte die je wilt behouden

            // Genereer QR-code als PNG met een canvas op 300 DPI
            const dpi = 300;
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            // Bepaal de grootte van de afbeelding (in pixels) die we willen genereren
            canvas.width = qrSizeInPixels * dpi / 72;  // Omzetten naar inch en DPI
            canvas.height = qrSizeInPixels * dpi / 72;

            // Genereer de QR-code op het canvas
            QRCode.toCanvas(canvas, prevTextVal, {
                width: qrSizeInPixels,
                margin: 1, // Minimaliseer witte ruimte
                color: {
                    dark: colors[prevVal] ?? "#000000",
                    light: '#0000',
                }
            }, (error) => {
                if (error) {
                    console.error('Fout bij het genereren van de QR-code op canvas:', error);
                    return;
                }

                // Verkrijg de afbeelding als PNG
                const dataUrl = canvas.toDataURL('image/png');

                // Maak een bestand van de PNG
                let blob = dataURItoBlob(dataUrl);
                let fileObj = new File([blob], 'qr-code.png', { type: 'image/png' });
                let dataTransfer = new DataTransfer();
                dataTransfer.items.add(fileObj);

                file = dataTransfer.files;

                // Voeg de PNG toe aan de image-url
                var $selector = $(".pplr-wrapper.pplr-_pplr_qr_black");
                if (prevVal == checkSwatchVal[1]) {
                    $selector = $(".pplr-wrapper.pplr-_pplr_qr_white");
                }

                if (blob) {
                    $selector.find("img.img_url").attr("data-psrc", window.URL.createObjectURL(blob));
                } else {
                    $selector.find("img.img_url").attr("data-psrc", prevVal == checkSwatchVal[1] ? prevSRCS[checkSwatchVal[1]] : prevSRCS[checkSwatchVal[0]]);
                }

                console.log(`PNG gegenereerd met 300 DPI, visuele grootte van ${qrSizeInPixels}px x ${qrSizeInPixels}px`);
            });
        };

        jQuery(`.pplr-swatch-element${swatchElName}`).on("click", function () {
            setTimeout(() => {
                let newVal = checkVal();
                if (prevVal == newVal) {
                    return;
                }
                prevVal = newVal;
                console.log(checkSwatchVal, checkSwatchVal?.includes(prevVal));
                if (!checkSwatchVal?.includes(prevVal)) {
                    removeSVg();
                    return;
                }
                generateQrCode();
            }, 200);
        });

        var timeout;
        jQuery(textInputElName).on("change keyup input", function () {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                let newVal = inputVal();
                if (prevTextVal == newVal) {
                    return;
                }
                prevTextVal = newVal;
                generateQrCode();
            }, 200);
        });
    });
});

// Hulpfunctie om een data URL om te zetten naar een Blob
function dataURItoBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/png' });
}
// JavaScript Document